import { useMemo } from 'react';
import useSWR from 'swr';
import { ResponseObject } from '../interfaces';
import request from '../utils/request';

export interface NetworkInfo {
  decimal: number;
  name: string;
  symbol: string;
  explorerAddress: string;
  explorerTx: string;
  explorerBlock: string;
}

/**
 * useNetworks
 */
export default function useNetworks() {
  return useSWR(
    '/api/v1/chain/list',
    url => request.post<ResponseObject<NetworkInfo[]>>(url),
    {
      refreshInterval: 12_000,
      keepPreviousData: true,
    }
  );
}
export function useNetwork(symbol?: string) {
  const { data } = useNetworks();
  return useMemo(
    () => data?.data.data?.find(val => val.symbol === symbol),
    [data, symbol]
  );
}
export function useNetworkName(symbol?: string) {
  const chain = useNetwork(symbol);
  return chain?.name;
}
export function useNetworkDecimal(symbol?: string) {
  const chain = useNetwork(symbol);
  return chain?.decimal;
}
export function useNetworkExplorer(symbol?: string) {
  const chain = useNetwork(symbol);
  return chain?.explorerAddress;
}
export function useNetworkExplorerTx(symbol?: string) {
  const chain = useNetwork(symbol);
  return chain?.explorerTx;
}
